import {EnvironmentMetadata} from '../environment-meta-data';
import {AppName, EnvironmentName} from '../environment-utils';

export class EnvironmentBroker implements EnvironmentMetadata {
  readonly showDevControls: boolean;
  readonly apiBase: string;
  readonly environment: EnvironmentName;
  readonly app: AppName;
  readonly msProposalApiBase: string;
  readonly msSaleApiBase: string;
  readonly msFnaApiBase: string;
  readonly enableProdMode?: boolean;
  readonly launchDarklyClientId?: string;
  readonly datadogLogsClientToken?: string;
  readonly version: string;

  constructor(configuration: EnvironmentMetadata) {
    this.showDevControls = configuration.showDevControls;
    this.apiBase = configuration.apiBase;
    this.environment = configuration.environment;
    this.app = configuration.app;
    this.msProposalApiBase = configuration.msProposalApiBase;
    this.msSaleApiBase = configuration.msSaleApiBase;
    this.msFnaApiBase = configuration.msFnaApiBase;
    this.enableProdMode = configuration.enableProdMode;
    this.launchDarklyClientId = configuration.launchDarklyClientId;
    this.datadogLogsClientToken = configuration.datadogLogsClientToken;
    this.version = configuration.version;
  }
}
